<template>
  <div data-test="usmediaslide" class="glide__slide">
    <USImage
      v-if="imgArgs"
      v-bind="imgArgs"
      :lazy="false"
      :manualLazy="lazy"
      :aspectRatio="aspectRatio"
      objectFit="cover"
      sizes="100vw"
    />
    <slot v-else />
  </div>
</template>
<script lang="ts">
import { defineComponent, PropType } from 'vue'

import USImage from '../USImage/USImage.vue'

// TODO src OR initials must be used
// TODO background must be specified if initials is used

interface imgArgs {
  src: string
  srcset?: string
  alt?: string
  title?: string
  objectPosition?: string
}

export default defineComponent({
  name: 'USMediaSlide',
  components: {
    USImage
  },
  props: {
    imgArgs: { type: Object as PropType<imgArgs> },
    aspectRatio: {
      type: String,
      default: '16:9',
      filter: (val: string) => {
        return ['16:9', '9:16', '4:3', '3:4', '1:1'].includes(val)
      }
    },
    lazy: {
      type: Boolean,
      default: false
    }
  }
})
</script>

<style lang="scss" scoped></style>
